/**
 * The base view for this application. Initialises all objects and global events
 * @class
 */

Selector.View.AppView = Backbone.View.extend(
/** @lends UserDocs.View.AppView# */
{
	/** The events we're listening to*/
    events: {
    	"click #e_selector_reset": "resetQuestionaire",
        "click .e_selector_button_start" : "start",
    	"click .e_selector_init" : "initSelector"
	},

    /** template to use for Underscore.js rendering */
    template: _.template($('#selector_base').html()),
	
	questionList: null,

	/** 
	 * Initialisation function called when this object is created. 
	 * Create all the 'global' objects to this app and trigger some rendering 
	 */
    initialize: function() {
    	
    	this.initSelector();
    },
    
    initSelector: function(supressIntroduction){

        //allows app to be loaded on page without the DOM element being present
        this.setElement($("#e_document_selector"));

        this.$el.html(this.template());//add the base DOM
        this.$el.find("#e_selector_reset").hide();
        this.$el.addClass("e_selector_introduction_wrapper");
        if (ele.selector.data) {
            this.start(supressIntroduction);
        }
    },

    destroySelector: function() {
        // COMPLETELY UNBIND THE VIEW
        this.undelegateEvents();

        this.$el.removeData().unbind();

        // Remove view from DOM
        this.remove();
        Backbone.View.prototype.remove.call(this);
    },

    start: function(supressIntroduction){

        let questionTabListView;

        this.$el.find("#e_selector_reset").show();

        this.questionList = new Selector.Collection.QuestionList;
        this.questionList.key = ele.selector.data.CONFIG.SELECTORTYPE + "_selector";
        this.questionList.set(this.questionList.parse(ele.selector.data.QUESTIONS));

        var questionListView = new Selector.View.QuestionListView({collection: this.questionList});
        //questionListView.render();
        
        if (ele.selector.data.CONFIG.SELECTORBEHAVIOUR === "TABS") {
            questionTabListView = new Selector.View.QuestionTabListView({collection: this.questionList});
        }

        //set up the result
        this.questionList.resultModel = new Selector.Model.Result({results: null, noResults: false, jurisdictionId: ele.selector.preSelectedJurisdiction});
        var resultView = new Selector.View.ResultView({model: this.questionList.resultModel, el: $(".e_selector_results")});

        if (ele.selector.data.CONFIG.SELECTORTYPE === "HumanResourcesCheckuphealthcheck"
            || ele.selector.data.CONFIG.SELECTORTYPE === 'ResidentialLandlordCheckuphealthcheck'
            || ele.selector.data.CONFIG.SELECTORTYPE === 'GeneralBusinessCheckuphealthcheck'
        ) {
            // Set up a jurisdiction selector view
            const jurisdictions = ele.selector.jurisdictions;

            // If this is a Jurisidction view
            const jurisdictionSelectView = new Selector.View.JurisdictionSelectView({
                jurisdictions: jurisdictions,
                resultModel: this.questionList.resultModel
            });

            // Render the view and append it to a DOM element
            $('#jurisdiction-container').append(jurisdictionSelectView.render().el);
        }

        //set up the landscape if it exists
        if (ele.selector.data.CONFIG.SELECTORTYPE === "landscape") {
            var landscapeView = new Selector.View.LandscapeView({collection: this.questionList});
        }

        this.questionList.resetAnswers();
        this.questionList.loadState();

        if (!supressIntroduction && ele.selector.data.TEXT.INTRODUCTION !== "" && this.questionList.resultModel.get("results") === null) {            
            /* introduction */
            var introTemplate = _.template($('#selector_introduction').html());

            this.$el.find(".e_selector_introduction").html(introTemplate(ele.selector.data.TEXT)).show();
            this.$el.find(".e_selector_questions").hide();
            this.$el.find("#e_selector_reset").hide();
            this.$el.find('.e_selector_tabs').hide();
            this.$el.addClass("e_selector_introduction_wrapper");
        } else {            
            this.$el.find('.e_selector_tabs').show();
            this.$el.find(".e_selector_introduction").hide();
            this.$el.find("#e_selector_reset").show();
            if (ele.selector.data.CONFIG.SELECTORBEHAVIOUR === "TABS") {
                this.$el.removeClass("e_selector_introduction_wrapper");
                questionTabListView.render();
            }
        }
    },
    
    resetQuestionaire: function(){

        this.questionList.resetAnswers();
        this.questionList.resetState();
        $(".e_selector_tabs").show();
    	
    	this.$el.css("min-height", 0)
        $(".e_selector_warnings").html("");

        this.start();
    	
		// $('html,body').animate({
		// 	scrollTop: $(".e_selector").offset().top
	    // }, 300);
    	
    	setTimeout(function(){
    	    if (ele.uri.getParameterByName(window.location.href, "sendEvents")) {
                var event = new CustomEvent('resizeIframe');
                window.parent.document.dispatchEvent(event);
                var event = new CustomEvent('scrollToIframe');
                window.parent.document.dispatchEvent(event);
            }
        }, 500);
    }
    
});

